export const iconFontAwesomeFilmVideoTv = (
	<i className="fa-solid fa-tv"></i>
);
